import React from "react";

const FormContainer = ({ children, className = "auth-card" }) => {
  return <section className={className}>{children}</section>;
};

export default FormContainer;
